var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 4.25H8.75V5.75H7.25V4.25ZM7.25 7.25H8.75V11.75H7.25V7.25ZM8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14Z",
    fill: "#00D68F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjUgNC4yNUg4Ljc1VjUuNzVINy4yNVY0LjI1Wk03LjI1IDcuMjVIOC43NVYxMS43NUg3LjI1VjcuMjVaTTggMC41QzMuODYgMC41IDAuNSAzLjg2IDAuNSA4QzAuNSAxMi4xNCAzLjg2IDE1LjUgOCAxNS41QzEyLjE0IDE1LjUgMTUuNSAxMi4xNCAxNS41IDhDMTUuNSAzLjg2IDEyLjE0IDAuNSA4IDAuNVpNOCAxNEM0LjY5MjUgMTQgMiAxMS4zMDc1IDIgOEMyIDQuNjkyNSA0LjY5MjUgMiA4IDJDMTEuMzA3NSAyIDE0IDQuNjkyNSAxNCA4QzE0IDExLjMwNzUgMTEuMzA3NSAxNCA4IDE0WiIgZmlsbD0iIzAwRDY4RiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };